import { useTranslation } from 'react-i18next';
import { SelectPicker } from 'rsuite';
import styled from 'styled-components';

import { APP_LANGUAGES } from '@/config/appConstants';

const LanguageSelectorWrap = styled.div``;

export const LanguageSelector = () => {
  const { t, i18n } = useTranslation();

  const data = APP_LANGUAGES.map((lang) => {
    return { label: t('Languages.' + lang), value: lang };
  });

  return (
    <LanguageSelectorWrap>
      <div className="language__selector max-w-[115px]">
        <SelectPicker
          data={data}
          placeholder={t('Languages.' + i18n.language)}
          placement="topStart"
          searchable={false}
          style={{ width: 224 }}
          onChange={(value) => {
            value && void i18n.changeLanguage(value);
          }}
        />
      </div>
    </LanguageSelectorWrap>
  );
};
